import React from 'react';

import { Button, Center, Flex, Image, Text, VStack } from '@chakra-ui/react';
import card from 'assets/images/blank-credit-card.svg';
import { useTranslation } from 'react-i18next';
import LabelValue from './LabelValue';

const NoPaymentCards = () => {
  const { t } = useTranslation();

  const handleAddCard = () => {
    'handleAddCard';
  };

  return (
    <Center
      bg="greyscale.100"
      borderRadius="lg"
      px={{ base: 4, md: 8 }}
      pt={{ base: 8, md: '128px' }}
      pb={{ base: 4, md: '128px' }}
    >
      <Flex
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        maxWidth={{ base: '100%', md: '375px' }}
        textAlign="center"
      >
        <Image src={card} maxWidth="200px" width="100%" mb={8} />
        <Text fontSize="lg" fontWeight="medium">
          No payment cards added
        </Text>
        <Text fontSize="md" color="greyscale.600">
          Add one with your first payment to save time in future.
        </Text>
        <Button
          size="s"
          onClick={handleAddCard}
          width="100%"
          my={4}
          data-testid="btn-add-card"
        >
          {t('common.add')}
        </Button>
        <VStack spacing={3} width="100%">
          <LabelValue label="Subscription amount" value="€42,99 / Year" />
          <LabelValue label="  Next payment date" value="17.06.2025" />
        </VStack>
      </Flex>
    </Center>
  );
};

export default NoPaymentCards;
